import { render, staticRenderFns } from "./courseplayer.vue?vue&type=template&id=ccc9a53c&scoped=true&"
import script from "./courseplayer.vue?vue&type=script&lang=js&"
export * from "./courseplayer.vue?vue&type=script&lang=js&"
import style0 from "./courseplayer.vue?vue&type=style&index=0&id=ccc9a53c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc9a53c",
  null
  
)

export default component.exports